import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { DocmanFileRest } from '../services/docman.service.file';
import { ModalComponent } from '../../../core/config/core.modal-helpers';

@Component({
  selector: 'file-version-delete-modal',
  template: require('./file.version.delete.modal.html')
})
export class FileVersionDeleteModalComponent extends ModalComponent implements OnInit {
  @Input() fileVersion: any; 
  @Output() onDelete = new EventEmitter<any>();;
  @Output() onClose = new EventEmitter<any>();;

  constructor(
    private docmanFileRest: DocmanFileRest
  ) {
    super();
  }

  ngOnInit() {}

  deleteFileVersion() {
    this.docmanFileRest.deleteFileVersion(this.fileVersion.id)
      .then(response => {
        this.onDelete.emit(this.fileVersion);
      }, (err: any) => {
        this.onClose.emit();
      });
  }
}
